import AuthClient from '@keethealth/auth-client';

export async function getCurrentSession() {
  return AuthClient.getCurrentSession();
}

export async function signOut() {
  return AuthClient.signOut();
}

export function authorize(opts = {}) {
  return AuthClient.authorize({
    redirectUri: process.env.REACT_APP_LOGIN_URL,
    extras: {
      ...opts,
    },
  });
}

export async function checkForResponse() {
  return AuthClient.checkForResponse();
}

export function getCurrentUser() {
  return AuthClient.getCurrentUser();
}
